import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MyCasesState } from '../reducers/my-cases.reducer';

export const selectMyCasesState = createFeatureSelector<MyCasesState>('myCases');

export const selectCases = createSelector(selectMyCasesState, state => state.cases);

export const selectCaseItem = createSelector(selectMyCasesState, state => state.caseItem);

export const selectCaseShipments = createSelector(selectCaseItem, state => state?.shipments || []);

export const selectShipment = createSelector(selectMyCasesState, state => state.shipment);

export const selectPending = createSelector(selectMyCasesState, state => state.pending > 0);

export const selectLoading = createSelector(selectMyCasesState, state => state.loading > 0);
